module.exports = __webpack_public_path__ + "img/120.76e79f8a.jpg";